/**
 * Notification Provider
 *
 * Provides global toast notifications throughout the application
 */

import type { ReactNode } from 'react'
import { ToastContainer } from '@/shared/components/errors/ErrorNotification'
import { useNotifications } from '@/shared/stores/notificationStore'

interface NotificationProviderProps {
  children: ReactNode
}

export function NotificationProvider({ children }: NotificationProviderProps) {
  const { notifications, removeNotification } = useNotifications()

  return (
    <>
      {children}
      <ToastContainer
        notifications={notifications}
        onDismiss={removeNotification}
        position='top-right'
      />
    </>
  )
}
